import { render, staticRenderFns } from "./chat_window.vue?vue&type=template&id=0d97b064&scoped=true"
import script from "./chat_window.vue?vue&type=script&lang=js"
export * from "./chat_window.vue?vue&type=script&lang=js"
import style0 from "./chat_window.vue?vue&type=style&index=0&id=0d97b064&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d97b064",
  null
  
)

export default component.exports